<template>
  <div class="message-files"
       :title="datetime">
    <div class="message-files__not-image"
         v-if="!isImage"
         @click="goToFile">
      <p class="Paragraph1 m-b-15">Sent a file</p>
      <div class="smd-panel smd-form__row m-b-10">
        <span class="file-icon"
              :class="computeFileIcon"/>
        <p class="file-name">{{ fileNameString }}</p>
      </div>
      <p class="Label1 gray-400">{{ formattedTime }}</p>
    </div>

    <a :href="img_url"
       target="_blank"
       class="message-files__image"
       v-if="isImage">
      <div v-if="loading" class="loading-spinner">
        <smd-loading-spinner></smd-loading-spinner>
      </div>
      <img v-if="img_url"
           :src="img_url"
           @load="imageLoaded">
      <p v-if="error" class="error">Preview not found.</p>
      <p class="text"><span :class="'ns-icon-attachment'"/> {{ fileNameString }}</p>
      <p class="gray-400 time">{{ formattedTime }}</p>
    </a>
  </div>

</template>

<script>
  import {MIME_TYPES, MESSAGE_PROP_MSG_TYPE} from '@/constants/inbox-messages';
  import {FilesService} from '@/services/files';
  import moment from 'moment';

  export default {
    name: "MessageFiles",
    props: {
      message: {type: Object, required: true},
      token: {type: String, required: true},
    },
    data() {
      return {
        error: null,
        img_url: null,
        loading: false,
      }
    },
    computed: {
      datetime() {
        return moment(this.message.received).format('MMMM D, YYYY hh:mm a');
      },
      computeFileIcon() {
        return this.message.mimetype === MIME_TYPES.pdf ? 'ns-icon-ico014' : 'ns-icon-text-file';
      },
      isImage() {
        const imageTypes = [MIME_TYPES.png, MIME_TYPES.jpg, MIME_TYPES.jpeg]
        return imageTypes.includes(this.message.mimetype);
      },
      fileNameString() {
        return this.message[MESSAGE_PROP_MSG_TYPE.file];
      },
      formattedTime() {
        return moment(this.message.received).format('hh:mm a');
      }
    },
    mounted() {
      if (this.isImage) {
        this.fetchFileImg();
      }
    },
    methods: {
      async goToFile() {
        this.error = null;
        try {
          const {data} = await FilesService.getFileURL(this.token, this.message.uploadid);
          if (!data) {
            throw Error();
          }
          window.open(`${data.url}`, '_blank');
        } catch (e) {
          this.error = 'An unexpected error occured on viewing your file.';
          this.$emit('file-view-error', this.error);
        }
      },
      async fetchFileImg() {
        this.error = null;
        this.loading = true;
        try {
          const {data} = await FilesService.getFileURL(this.token, this.message.uploadid);
          if (!data) {
            throw Error();
          }

          this.loading = false;
          this.img_url = data.url;
        } catch (e) {
          this.loading = false;
          this.error = 'An unexpected error occured on fetching the image.';
          this.$emit('file-img-error', this.error);
        }
      },
      imageLoaded() {
        this.$emit('loaded');
      },
    }
  }
</script>

<style lang="scss">
  .message-files__not-image {
    @extend %layout--flex-col;
    background: color(gray-50);
    border-radius: radius(medium);
    padding: space(s) space(m);
    cursor: pointer;

    .file-icon {
      font-size: font(xxl);
      color: color(gray, text);
    }

    .file-name {
      @include font-style(Title3);
    }
  }

  .message-files__image {
    position: relative;
    display: block;
    max-width: 66.66%;
    overflow: hidden;
    border: 1px solid color(light, border);
    border-radius: radius(medium);
    cursor: pointer;

    img {
      display: block;
      width: 100%;
    }

    .loading-spinner {
      padding: space(s);
    }

    .error {
      text-align: center;
      padding: space(s);
      color: color(red, brand);
    }


    .text, .time {
      color: color(base, text);
      background-color: color(light, segment);
    }

    .text {
      padding: space(s) space(m);
    }

    .time {
      text-align: right;
      padding: space(xs) space(m);
    }
  }
</style>